import {
  MGParseFloat,
  MGParseInt,
  MGParsePercent,
} from "../../components/Table/MetricGoalsTable/utils"

export const fixNumber = (value: string | null, type: string, precision:any) => {
  if (value) {
    const parseFun =
      type === "#" ? MGParseInt : type === "%" ? MGParsePercent : MGParseFloat
    return parseFun(value, precision)
  }
}
